'use strict';

/**
 * @param {integer} endDateTime - Timer end date
 * @returns {Object} - returns json
 */
function getTimeRemaining(endDateTime) {
    var t = Date.parse(endDateTime) - Date.parse(new Date());
    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;
    var clockJson = {
        days: Math.floor(t / days),
        hours: Math.floor((t % days) / hours),
        minutes: Math.floor((t % hours) / minutes),
        seconds: Math.floor((t % minutes) / seconds)
    };
    return {
        total: t,
        minutes: clockJson.minutes,
        seconds: clockJson.seconds,
        hours: (clockJson.days * 24) + clockJson.hours
    };
}

/**
 * @param {integer} id - div id to show the timer
 * @param {string} endDateTime - Timer end date
 */
function initializeClock(id, endDateTime) {
    // eslint-disable-next-line no-unused-vars
    var timeinterval;
    var hoursSpan = id.find('.hours');
    var minutesSpan = id.find('.minutes');
    var secondsSpan = id.find('.seconds');
    const updateClock = function () {
        var t = getTimeRemaining(endDateTime);

        hoursSpan.html(t.hours + ' :');
        minutesSpan.html(('0' + t.minutes).slice(-2) + ' :');
        secondsSpan.html(('0' + t.seconds).slice(-2));

        if (t.total <= 0) {
            id.hide();
        }
    };
    updateClock();
    timeinterval = setInterval(updateClock, 1000);
}
module.exports = function () {
    if (document.getElementsByClassName('clockdiv') == null) {
        return;
    }
    $(document).ready(function () {
        var $clockDiv = $('.clockdiv');
        if ($clockDiv.length) {
            $clockDiv.each(function (index) {
                var $currentClock = $($clockDiv[index]);
                var $timerEndDateTime = $currentClock.find('.timerEndDateTime');

                // Time as set in promotion component
                const endDateTimeLocal = new Date($timerEndDateTime.text().replace(/-/g, '/'));

                if (endDateTimeLocal instanceof Date && !isNaN(endDateTimeLocal)) {
                    // converting the Time Zone to UTC
                    let endDateTime = new Date(Date.UTC(endDateTimeLocal.getFullYear(), endDateTimeLocal.getMonth(), endDateTimeLocal.getDate(), endDateTimeLocal.getHours(), endDateTimeLocal.getMinutes(), endDateTimeLocal.getSeconds()));

                    // Adding hours based on daylight saving to get CST TimeZone
                    var dstHours = $timerEndDateTime.data('dst-hours') ? $timerEndDateTime.data('dst-hours') : 5;
                    endDateTime.setHours(endDateTime.getHours() + parseInt(dstHours, 10));

                    initializeClock($currentClock, endDateTime);
                } else {
                    $clockDiv.find('.clock-timer').hide();
                }
            });
        }
    });
};
